import request from '@/utils/request'

// 公开配置（含爱豆换算率 bean.per_yuan）
export function getPublicConfigs() {
  return request({
    url: '/system/config/public',
    method: 'get'
  })
}
